import { FC } from 'react';

import Table from 'modules/_shared/Table';

import CoOwnersTableBody from './CoOwnersTableBody';
import CoOwnersTableHeader from './CoOwnersTableHeader';

const CoOwnersTable: FC = () => {
  const content = (
    <>
      <CoOwnersTableHeader />
      <CoOwnersTableBody />
    </>
  );

  return (
    <Table className="table custom-table coOwners-table" content={content} />
  );
};

export default CoOwnersTable;
